import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import Settings from "../Settings";
import enCommon from "./en/common.json";
import svCommon from "./sv/common.json";
import noCommon from "./no/common.json";
import nnCommon from "./nn/common.json";
/* eslint-disable unused-imports/no-unused-imports, @typescript-eslint/no-unused-vars */
import deCommon from "./de/common.json";
import esCommon from "./es/common.json";
import frCommon from "./fr/common.json";
/* eslint-enable unused-imports/no-unused-imports, @typescript-eslint/no-unused-vars */
import { getLanguageCode } from "@/utils/obj";

export const resources = {
  en: {
    common: enCommon,
  },
  no: {
    common: noCommon,
  },
  sv: {
    common: svCommon,
  },
  nn: {
    common: nnCommon,
  },
  // fr: {
  //   common: frCommon,
  // },
  // de: {
  //   common: deCommon,
  // },
  // es: {
  //   common: esCommon,
  // },
};

i18n
  .use(LanguageDetector)
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: false,
    },
    fallbackLng: (code) => getLanguageCode(code),
    ns: ["common", "db"],
    defaultNS: "common",
    lowerCaseLng: true,
    cleanCode: true,
    debug: Settings.DEBUG_I18NEXT,
    resources,
    backend: {
      loadPath:
        `${Settings.TRANSLATIONS_API_ENDPOINT}{{lng}}.json` ||
        `${Settings.API_BASE_HOST}/admin/api/translations/{{lng}}.json`,
    },
  })
  // reloadResources must be called for HttpBackend to fetch the db translations
  .then(() => i18n.reloadResources(null, ["db"], () => {}));

export default i18n;
